export default "__VITE_ASSET__DSXNp8ch__"